/**
 * A modern JavaScript utility library delivering modularity, performance & extras.
 */
// window._ = require('lodash');
// require('@babel/polyfill');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
// window.Vue = require('vue');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

/**
 * Moment.js is a powerful javascript library that can create and format date
 * and time instances. We use it troughout the whole application. The lang
 * attribute of the document will be set as the locale.
 */

window.moment = require('moment');
require('moment/locale/nl');

// Change english start of the week to monday
moment.updateLocale('en', {
    week: {
        dow: 1,
    },
});

// Load the correct locale
moment.locale(document.documentElement.lang);

/**
 * Modernizr touchevents test
 */
require('browsernizr/test/touchevents');
require('browsernizr/test/elem/picture');
window.Modernizr = require('browsernizr');

/**
 * Smooth animated scrolling. Move elements into view, or scroll to any vertical position.
 */
window.zenscroll = require('zenscroll');

/**
 * Headroom.js is a lightweight, high-performance JS widget that allows you to react to the user's scroll.
 */
window.Headroom = require('headroom.js');

/**
 * Application session to keep track of the Ticketlab cart.
 */
window.ticketlabId = document.head.querySelector('meta[name="ticketlab-session"]').content;

/**
 * Application base url, useful to make locale aware ajax calls.
 */
const base = document.head.querySelector('meta[name="base-url"]');
if (base) {
    window.applicationBaseUrl = base.content;
}

/**
 * Unregister the ServiceWorker
 */
/* eslint-disable */
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(

        function (registrations) {

            for (let registration of registrations) {
                registration.unregister();

            }

        });
}

window.bodyScrollLock = require('body-scroll-lock');

window.MobileDetect = require('mobile-detect');